import { useState } from "react";


function Team(team) {
  const [selectedMember, setSelectedMember] = useState(null);

   if (!team?.team?.services_list?.length) {
    return null;
  }
  
  const openModal = (member) => setSelectedMember(member);
  const closeModal = () => setSelectedMember(null);

  return (
    <>
      {
        Object.keys(team).length &&
        <div className="team section mb-100">
          <div className="container">
            {team?.team?.highlist_title && (
            <div className="section-title2 primary3 text-start">
              <span>Meet Our Officers</span>
              <h2>{team.team.highlist_title}</h2>
            </div>
            )}
            <div className="team-members">
              {
                team.team.services_list && team.team.services_list.length > 0 &&
                team.team.services_list.map((member, index ) => {
                  return (
                    <div className="single-team2 glass-effect"  key={member.id || index}>
                      <div className="team-image">
                        <img src={member.icon_image} alt="member" className="img-fluid" />
                        <div className="read-more" onClick={() => openModal(member)}>
                          <span>Read Bio</span>
                        </div>
                      </div>

                      <div className="team-content">
                        <div className="team-data-wrap">
                          <h4 className="name">{member.title}</h4>
                          <p className="designation">{member.services_sub_title}</p>
                          {/* <p className="designation">{member.sub_section_title2 ? member.sub_section_title2 : ''}</p> */}
                        </div>
                        <div className="social-area social-icons gap-3">
                          <ul className="social-links d-flex justify-content-center align-items-center flex-row gap-3">

                            {member.instagram_url && (
                              <li>
                                <a href={`${member.instagram_url}`} target="_blank" rel="noreferrer">
                                  <i className="bx bxl-instagram" />
                                </a>
                              </li>)
                            }
                            {member.facebook_url && (
                              <li>
                                <a href={`${member.facebook_url}`} target="_blank" rel="noreferrer">
                                  <i className="bx bxl-facebook" />
                                </a>
                              </li>
                            )}
                            {member.twitter_url && (
                              <li>
                                <a href={`${member.twitter_url}`} target="_blank" rel="noreferrer">
                                  <i className="bx bxl-twitter" />
                                </a>
                              </li>
                            )}
                            {member.pinterest_url && (
                              <li>
                                <a href={`${member.pinterest_url}`} target="_blank" rel="noreferrer">
                                  <i className="bx bxl-pinterest-alt" />
                                </a>
                              </li>

                            )}

                            {member.linkedin_url && (

                              <li>
                                <a href={`${member.linkedin_url}`} target="_blank" rel="noreferrer">
                                  <i className="bx bxl-linkedin" />
                                </a>
                              </li>
                            )}

                          </ul>
                        </div>
                      </div>
                    </div>
                  )
                    })
                  }
            </div>
          </div>

          {selectedMember && (
            <div className="team-modal">
              <div className="modal-backdrop" onClick={closeModal}
              ></div>

              <div className="modal-content">
                <button className="close-btn" onClick={closeModal} >
                  ×
                </button>

                <div className="content">
                  <div className="image">
                    <img
                      src={selectedMember.icon_image}
                      alt={selectedMember.title}
                      className="team-photo"
                    />
                  </div>

                  <div className="data">
                    <h4 className="team-name">
                      {selectedMember.title}
                    </h4>
                    <p className="team-role">
                      {selectedMember.services_sub_title}
                    </p>
                    <p className="bio">
                      {selectedMember.short_description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      }
    </>
  );
}

export default Team;
